// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1971) return "static/chunks/02d30405-5eeadedc11285f81.js";
	if (chunkId === 76) return "static/chunks/76-c2014ad15d804dd2.js";
	if (chunkId === 4094) return "static/chunks/4094-8118fb5b75e7d3f3.js";
	if (chunkId === 6502) return "static/chunks/6502-d64e97d1b66a9541.js";
	if (chunkId === 7600) return "static/chunks/7600-99ccb8db8427191e.js";
	if (chunkId === 8594) return "static/chunks/8594-b207732acd31433d.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"54":"0fbc1475b2b96a07","2592":"501fff5d198f8b18","3156":"c38b8e787d86ab0c","3514":"d450043bd8e54102","4686":"bfd59265abc97dd3","5891":"fa5eeeafe4ff860f","6534":"6bfbd467d772a951","9724":"4eef85b2c0e7c17d"}[chunkId] + ".js";
};